import { isFalsy } from 'lib/Helpers';

import * as styles from '../Trend.scss';

const classMap = {
  svg: {
    empty: styles.emptyArrow,
    negative: styles.negativeArrow,
    positive: styles.positiveArrow,
  },
  value: {
    empty: styles.emptyTrend,
    negative: styles.negativeTrend,
    positive: styles.positiveTrend,
  },
};

/**
 * @function determineTrendClass
 * @param {Object} trendProps
 * @return {string}
 */
const determineTrendClass = trendProps => {
  if (isFalsy(trendProps)) return null;

  const { float, key } = trendProps;
  /* Cannot evaluate correct classNames without valid key */
  if (isFalsy(key)) return null;
  /* Return the empty class for zero or null values in float */
  if (isFalsy(float)) return classMap[key].empty;
  /* Evaluate positive/negative sign and return correct class */
  return Math.sign(float) === 1
    ? classMap[key].positive
    : classMap[key].negative;
};

export default determineTrendClass;
